export default "__VITE_ASSET__j6A6tbOs__"